import React from 'react';
import { Stack } from '@mui/material';
import Chat from '@/components/FileViewer/AIPanel/FileViewerAIPanel/Chat';
import { useFileSuggestion } from '@/hooks/apiHooks/file';

export type FileViewerAIPanelProps = {
  isMobile: boolean;
  onCloseList?: () => void;
  fileUuid: string;
  fileName?: string;
};

export default function FileViewerAIPanel({
  onCloseList,
  isMobile,
  fileUuid,
  fileName,
}: FileViewerAIPanelProps) {
  const { data } = useFileSuggestion(fileUuid);
  const suggestions = data?.suggestions ?? [];

  // 헤더(타이틀/채팅 초기화/닫기)는 공용 AiChatView 헤더가 담당한다(회의록과 동일).
  // 모바일은 시트 높이를 채우는 Chat만 렌더(드로어는 headerless).
  if (isMobile) {
    return (
      <Chat
        isMobile
        fileUuid={fileUuid}
        fileName={fileName}
        suggestions={suggestions}
        onCloseList={onCloseList}
      />
    );
  }

  return (
    <Stack
      sx={{
        height: '100%',
        padding: '32px 24px',
        '--text-primary-color': '#FFFFFF',
        '--text-secondary-color': '#888D96',
        '--card-background-color': 'transparent',
        '--border-color': '#1F2327',
        '--button-background-color': 'var(--GrayScale-gray_White, #2B2D2F)',
        '--button-hover-color': '#505560',
        '--button-active-color': '#C77AC4',
        '--button-icon-color': '#111315',
        '--button-disabled-icon-color': '#111315',
        '--Status-Disabled': '#464C53',
        '--effect-black-16': 'rgba(255, 255, 255, 0.16)',
      }}
    >
      <Stack
        sx={{
          overflow: 'hidden',
          height: '100%',
          borderRadius: '16px',
          border: '1px solid var(--GrayScale-gray_3, #393D41)',
          background: 'var(--GrayScale-gray_White, #2B2D2F)',
        }}
      >
        <Chat
          isMobile={false}
          fileUuid={fileUuid}
          fileName={fileName}
          suggestions={suggestions}
          onCloseList={onCloseList}
          sx={{ height: '100%' }}
        />
      </Stack>
    </Stack>
  );
}
